var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInvoice = function SvgInvoice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24805 6C2.24805 3.37665 4.37469 1.25 6.99805 1.25H16.998C19.6214 1.25 21.748 3.37665 21.748 6V18C21.748 20.6234 19.6214 22.75 16.998 22.75H6.99805C4.37469 22.75 2.24805 20.6234 2.24805 18V6ZM6.99805 2.75C5.20312 2.75 3.74805 4.20507 3.74805 6V18C3.74805 19.7949 5.20312 21.25 6.99805 21.25H16.998C18.793 21.25 20.248 19.7949 20.248 18V6C20.248 4.20507 18.793 2.75 16.998 2.75H6.99805Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24805 7C6.24805 6.58579 6.58383 6.25 6.99805 6.25L16.998 6.25C17.4123 6.25 17.748 6.58579 17.748 7C17.748 7.41421 17.4123 7.75 16.998 7.75L6.99805 7.75C6.58383 7.75 6.24805 7.41421 6.24805 7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24805 12C6.24805 11.5858 6.58383 11.25 6.99805 11.25L16.998 11.25C17.4123 11.25 17.748 11.5858 17.748 12C17.748 12.4142 17.4123 12.75 16.998 12.75L6.99805 12.75C6.58383 12.75 6.24805 12.4142 6.24805 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24805 17C6.24805 16.5858 6.58383 16.25 6.99805 16.25L11.998 16.25C12.4123 16.25 12.748 16.5858 12.748 17C12.748 17.4142 12.4123 17.75 11.998 17.75H6.99805C6.58383 17.75 6.24805 17.4142 6.24805 17Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInvoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "invoice.5bdd33e8fa76c1edff3cad456e325f8d.svg";